<template>
  <div class="scrollbar-sidebar">
    <div class="app-sidebar__inner">
      <ul class="vertical-nav-menu">
        <li class="app-sidebar__heading">Menu</li>
        <li>
          <router-link
            :to="{ name: 'ListarInstituciones' }"
            v-if="!institucionSelected"
          >
            <i class="metismenu-icon fas fa-school"></i>
            Instituciones
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'ListarLiquidaciones' }"
            v-if="institucionSelected"
          >
            <i class="metismenu-icon fas fa-file-alt"></i>
            Liquidaciones
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'ListarPersonas' }">
            <i class="metismenu-icon fas fa-user"></i>
            Personas
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'ListarLegajos' }"
            v-if="institucionSelected"
          >
            <i class="metismenu-icon fas fa-file-invoice"></i>
            Legajos
          </router-link>
        </li>
        <li>
          <a style="cursor: pointer" v-if="institucionSelected" @click="abrirModalPeriodo = true">
            <i class="metismenu-icon fas fa-file-contract"></i>
            F931
          </a>
        </li>
        <li>
          <a style="cursor: pointer" v-if="institucionSelected" @click="abrirModalAportes = true">
            <i class="metismenu-icon fas fa-file-invoice-dollar"></i>
            Aportes
          </a>
        </li>
        <li>
          <a href="#">
            <i class="metismenu-icon fas fa-file-contract"></i>
            Libro digital
            <i class="metismenu-state-icon pe-7s-angle-down caret-left"></i>
          </a>
          <ul>
            <li v-if="institucionSelected">
              <a target="_blank"
                 :href="libroDigitalConceptosURL"
              >Conceptos
              </a>
              <a style="cursor: pointer" v-if="institucionSelected" @click="abrirModalLibroDigital = true">
                Liquidaciones
              </a>
            </li>
          </ul>
        </li>
        <li>
          <a href="#">
            <i class="metismenu-icon fas fa-cogs"></i>
            Configuracion de sistema
            <i class="metismenu-state-icon pe-7s-angle-down caret-left"></i>
          </a>
          <ul>
            <li v-if="institucionSelected">
              <router-link :to="{ name: 'ListarConceptos' }"
              >Conceptos
              </router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'ListarTipoLiquidacion' }"
              >Tipos liquidación
              </router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'ListarCategorias' }"
              >Categorias
              </router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'ListarCargos' }">Cargos</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'ListarSituacionRevista' }"
              >Situacion de revista
              </router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'ListarSindicatos' }"
              >Sindicatos
              </router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'ListarRegimenJubilatorio' }"
              >Regimen Jubilatorio
              </router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'ListarPlanMedico' }"
              >Plan Medico
              </router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'ListarObraSocial' }"
              >Obra Social
              </router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'ListarModalidadContrataciones' }"
              >Modalidad Contratacion
              </router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'ListarSecciones' }"
              >Seccion
              </router-link
              >
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <ModalSelectPeriodo v-if="abrirModalPeriodo" @cerrarSelectPeriodo="abrirModalPeriodo = false"/>
    <ModalSelectPeriodoForAportes v-if="abrirModalAportes" @cerrarSelectPeriodo="abrirModalAportes = false"/>
    <ModalSelectLibroDigitalPeriodo v-if="abrirModalLibroDigital" @cerrarSelectPeriodo="abrirModalLibroDigital = false"/>
  </div>
</template>
<script>
import Vuex from "vuex";
import ModalSelectPeriodo from "@/components/views/f931/ModalSelectPeriodo";
import axios from "axios";
import ModalSelectLibroDigitalPeriodo from "@/components/views/libroDigital/ModalSelectLibroDigitalPeriodo.vue";
import ModalSelectPeriodoForAportes from "@/components/views/aportes/ModalSelectPeriodoForAportes.vue";

export default {
  name: "Sidebar",
  methods: {axios},
  components: {
    ModalSelectLibroDigitalPeriodo,
    ModalSelectPeriodo,
    ModalSelectPeriodoForAportes,
  },
  data() {
    return {
      institucionSelected: false,
      abrirModalPeriodo: false,
      abrirModalAportes: false,
      abrirModalLibroDigital: false
    };
  },
  computed: {
    ...Vuex.mapState(["institucion"]),
    libroDigitalConceptosURL: function () {
      return `${axios.defaults.baseURL}/libro-digital/conceptos?institucionId=${this.institucion.id}`
    }
  },
  watch: {
    institucion: function (institucion) {
      if (institucion) {
        this.institucionSelected = true;
      } else {
        this.institucionSelected = false;
      }
    },
  },
  mounted() {
    if (this.institucion) {
      this.institucionSelected = true;
    } else {
      this.institucionSelected = false;
    }
  },
};
</script>
